import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface ApplyConditionLineSheetSetParameter {
  lineSheetSetId: number;
}

export interface ApplyConditionLineSheetSetRequest {
  conditions: {
    brand_id?: number | null;
    line_sheet_id?: number | null;
    line_sheet_product_id?: number | null;
    season?: string | null;
    price_adjusted_by: {
      by: "MARKUP" | "DISCOUNT";
      value: number;
    };
  }[];
}

export interface ApplyConditionLineSheetSetResponse {}

export const applyConditionLineSheetSetTemplateUrl =
  "/line-sheet-sets/:lineSheetSetId/apply-condition";

export const applyConditionLineSheetSetKey: YWRKey<ApplyConditionLineSheetSetParameter> =
  {
    url: (parameter) =>
      calcUrl(applyConditionLineSheetSetTemplateUrl, parameter),
    method: "post",
  };

export default function useApplyConditionLineSheetSet() {
  const fetcher = useFetcher<
    ApplyConditionLineSheetSetRequest,
    ApplyConditionLineSheetSetResponse
  >();
  return useYWR(applyConditionLineSheetSetKey, fetcher);
}
